import { DItemConfiguracion, DItemRangoCasillas } from '@dian-cmp/formulario';
import { DInterfaceConfiguracionFormulario, DTipoOperacionAritmetica, DTipoRegla } from '@dian-cmp/formulario';
import { IDObserverTimerSession } from '@dian/core';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DContextoUsuarioServicio } from '@dian/api-identidad';

export class DObserverTimerSessionApp implements IDObserverTimerSession{
    
    constructor(
        private dNotificacionServicio: DNotificacionServicio,
        private dContextoUsuarioServicio: DContextoUsuarioServicio
    ) {}
    
    public cerrarSession(){
        let dialogo = this.dNotificacionServicio.mostrarDialogoInformacion('Su sesión ha expirado');
        dialogo.afterClosed().subscribe(result => {
            this.dContextoUsuarioServicio.logOut();
        });
    }
}

export class DFormularioConfiguracion implements DInterfaceConfiguracionFormulario {

    public USA_FORMULARIO_PAGO_NUEVO: boolean = true;
    public SOLO_USUARIO_INVITADO: boolean = false;
    public NUMERO_FORMULARIO = 490;//numero formulario ejemplo
    public VERSION_FORMATO = 7;//numero de la version del formato
    public NUMERO_FORMULARIO_CATATUMBO = 3111;//numero formulario ejemplo
    public NUMERO_FORMULARIO_MINTRANSPORTE = 2000;//numero formulario ejemplo
    public VERSION_FORMATO_CATATUMBO = 1;//numero de la version del formato
    public VERSION_FORMATO_MINTRANSPORTE = 9;//numero de la version del formato
    public PUEDE_SUBIR_ARCHIVOS: boolean = false;
    public USA_CERTIFICADO_FIRMA_OBLIGATORIO = false;
    public CASILLA_NIT:string = 'cs_id_5'; //le indica al framework cual es la casilla del nit 
    public CASILLA_ES_CORRECCION:string = '';//le indica al framework cual es la casilla de correccion
    public CASILLA_SANCION:string = '';//le indica al framework cual es la casilla de sancion
    public CASILLA_NUM_FORM_ANTERIOR:string = '';//le indica al framework cual es la casilla del numero de formulario anterior
    public RANGO_CUERPO = new DItemRangoCasillas(24, 91);//rango ejemplo
    public REGLAS_FORMULARIO:Array<DItemConfiguracion> = [//modelo ejemplo        
        //oblilgado
        {casilla: 'cs_id_24', tipoDato:'string', redondear: false, editable: false, validaciones:{}},
        {casilla: 'cs_id_25', tipoDato:'string', redondear: false, editable: false, validaciones:{}},
        {casilla: 'cs_id_26', tipoDato:'string', redondear: false, editable: false, validaciones:{}},
        //pagos
        {casilla: 'cs_id_27', tipoDato:'number', redondear: false, editable: false, validaciones:{}},
        {casilla: 'cs_id_28', tipoDato:'number', redondear: false, editable: false, validaciones:{}},
        {casilla: 'cs_id_29', tipoDato:'string', redondear: false, editable: false, validaciones:{}},
        {casilla: 'cs_id_30', tipoDato:'string', redondear: false, editable: false, validaciones:{}},
        {casilla: 'cs_id_31', tipoDato:'string', redondear: false, editable: false, validaciones:{}},
        {casilla: 'cs_id_32', tipoDato:'string', redondear: false, editable: false, validaciones:{}},
        {casilla: 'cs_id_33', tipoDato:'number', redondear: false, editable: false, validaciones:{}},
//catatumbo
        {casilla: 'cs_id_70', tipoDato:'number', redondear: false, editable: false, validaciones:{}},

        {casilla: 'cs_id_34', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_35', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_36', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_37', tipoDato:'string', redondear: false, editable: false, validaciones:{}},
        {casilla: 'cs_id_38', tipoDato:'string', redondear: false, editable: false, validaciones:{}}, 
        {casilla: 'cs_id_39', tipoDato:'string', redondear: false, editable: false, validaciones:{}}, 
        {casilla: 'cs_id_40', tipoDato:'string', redondear: false, editable: false, validaciones:{}}, 
        {casilla: 'cs_id_41', tipoDato:'string', redondear: false, editable: false, validaciones:{}}, 
        {casilla: 'cs_id_42', tipoDato:'string', redondear: false, editable: false, validaciones:{}},         
        {casilla: 'cs_id_43', tipoDato:'string', redondear: false, editable: false, validaciones:{}}, 
        //deudor solidario o subsidiario 
        {casilla: 'cs_id_44', tipoDato:'string', redondear: false, editable: false, validaciones:{}},
        {casilla: 'cs_id_45', tipoDato:'string', redondear: false, editable: false, validaciones:{}},
        {casilla: 'cs_id_46', tipoDato:'string', redondear: false, editable: false, validaciones:{}},
        {casilla: 'cs_id_47', tipoDato:'string', redondear: false, editable: false, validaciones:{}},
        {casilla: 'cs_id_48', tipoDato:'string', redondear: false, editable: false, validaciones:{}},
        {casilla: 'cs_id_49', tipoDato:'string', redondear: false, editable: false, validaciones:{}},
        
        {casilla: 'cs_id_90', tipoDato:'number', redondear: false, editable: false, validaciones:{}},
        {casilla: 'cs_id_91', tipoDato:'string', redondear: false, editable: false, validaciones:{}}
    ];

}



// WEBPACK FOOTER //
// D:/github/490/rec_ng_recibopago490v7/src/app/configuracion/dformulario-configuracion.ts